import React from 'react';
import MUIDataTable from 'mui-datatables';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles'

type Props = {
    list: any,  
    clickHandlerClose?: () => void,
}

const RegistrationUserListForm: React.FC<Props> = (props) => {

    const columns = [

        {
            name: 'item',
            label: props.list.title,
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    display: false,
                    align: "left",
                    }),
                setCellProps: () => ({
                    align: "left"
                }),
            }
        }
    ]


    const defaultGridTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''                    
                }
            }
        }
    })  
      
    return (
            <MuiThemeProvider theme={defaultGridTheme}>
                <MUIDataTable 
                    
                    title=""
                    data={props.list.items}
                    columns={columns}
                    options={{ 
                        
                        serverSide: false,
                        pagination: true,
                        sort: false,
                        selectToolbarPlacement: "none",
                        filter: false,
                        search: true,
                        download: false,
                        print: false,
                        viewColumns: false,
                        selectableRows: 'none',

                    }} />
            </MuiThemeProvider>
    )
}
export default RegistrationUserListForm
